module.exports = "div.w3-display-container {\r\n    margin-top: 150px;\r\n    min-height: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/errors/not-available/not-available.component.css
// module id = ./src/app/components/errors/not-available/not-available.component.css
// module chunks = main